import { Nav, Tab } from "react-bootstrap";
import { ILicenseeReturnDetails } from "../../../api/ILicenseeReturns";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { InstructionsGrid } from "../../../leap-components/Instructions/InstructionsGrid";
import { NonCompliancesGrid } from "../../../leap-components/NonCompliances/NonCompliancesGrid";
import { RequestsForInformationGrid } from "../../../leap-components/RequestsForInformation/RequestsForInformationGrid";
import { SiteVisitsGrid } from "../../../leap-components/SiteVisits/SiteVisitsGrid";
import { SiteVisitRegardingObjectTypes } from "../../../leap-components/SiteVisits/SiteVisitsGridProps";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceProfile: ILicenceProfile;
  licenseeReturn: ILicenseeReturnDetails;
}

interface LicenseeReturnsProps {
  licenceProfile: ILicenceProfile;
  licenseeReturn: ILicenseeReturnDetails;
}

const RequestsForInformation = ({
  licenceProfile,
  licenseeReturn,
}: LicenseeReturnsProps) => (
  <RequestsForInformationGrid
    licenceProfile={licenceProfile}
    licenseeReturnId={licenseeReturn.licenseereturnid}
  />
);

const Instructions = ({
  licenceProfile,
  licenseeReturn,
}: LicenseeReturnsProps) => (
  <InstructionsGrid
    licenseeReturnId={licenseeReturn.licenseereturnid}
    licenceProfile={licenceProfile}
  />
);

const SiteVisits = ({
  licenceProfile,
  licenseeReturn,
}: LicenseeReturnsProps) => (
  <SiteVisitsGrid
    regardingObjectType={SiteVisitRegardingObjectTypes.LR}
    regardingObjectId={licenseeReturn.licenseereturnid}
  />
);

const SubTabs = ({
  className,
  activeKey,
  licenseeReturn,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="rfis">Requests for Information</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="instructions">Instructions</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="non-compliances">Non Compliances</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="site-visits">Site Visits</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={licenseeReturn.licenseereturnid} />
        </Tab.Pane>
        <Tab.Pane eventKey="rfis">
          <RequestsForInformation
            licenceProfile={licenceProfile}
            licenseeReturn={licenseeReturn}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="instructions">
          <Instructions
            licenceProfile={licenceProfile}
            licenseeReturn={licenseeReturn}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="site-visits">
          <SiteVisits
            licenceProfile={licenceProfile}
            licenseeReturn={licenseeReturn}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="non-compliances">
          <NonCompliancesGrid
            relatedRecordId={licenseeReturn.licenseereturnid}
            relatedRecordType="Licensee Return"
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  licenceProfile,
  licenseeReturn,
}: LicenseeReturnsProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      licenceProfile={licenceProfile}
      licenseeReturn={licenseeReturn}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
